import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Chart } from 'chart.js';
import { ReportService } from 'src/app/dashboard/shared/services/report.service';
import { ReportingService } from 'src/app/reporting/shared/services/reporting.service';

import { DigitalIODataChannelGraphData } from '../../interfaces/digitalIO-graph-data.interface';
import {DataEndChannelTypeEnum} from 'src/app/project/shared/enums/data-end-channel-type.enum';

@Component({
  selector: 'avs-stm-chart',
  templateUrl: './stm-chart.component.html',
  styleUrls: ['./stm-chart.component.css']
})
export class StmChartComponent implements OnDestroy {

  public samId: number;
  public deviceName: string = "";
  public now = new Date();
  public nowAsISOString: string;
  public twoDaysAgoAsString: string;

  public fromDate: number = 2;
  public toDate: number = 0;
  public dataAge: number = 0;
  public fontSize: number = 10;
  public chartDefs: { [key: string]: {[key: string]:string}}= {
      "de1":{"de": "1", "title":"Eingang 1", "color": "rgba(0, 0, 255, 0.8)"}, 
      "de2":{"de": "2", "title":"Eingang 2", "color": "rgba(255, 0, 0, 0.8)"}, 
      "de3":{"de": "3", "title":"Eingang 3", "color": "rgba(0, 255, 255, 0.8)"}, 
      "de4":{"de": "4", "title":"Eingang 4", "color": "rgba(255, 180, 0, 0.8)"}, 
      "de7":{"de": "7", "title":"Ausgang", "color": "rgba(0, 0, 0, 0.8)"}
  };

  public ioChannelsActive: { [key: string]: boolean}= {};
  public lastData: DigitalIODataChannelGraphData[] | undefined = undefined;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any,
    private reportService: ReportService,
    private reportingService: ReportingService,
    private dialogRef: MatDialogRef<StmChartComponent>) {
    let lastData = new Date(this.data.schemaInfo?.solar?.data?.dataDateTime ?? NaN)
    let today = new Date()
    let diff = today.getTime() - lastData.getTime()
    let diffDays = diff / (1000 * 60 * 60 * 24)
    this.dataAge = diffDays
    if (this.dataAge !== undefined && this.dataAge > 1) { 
      this.toDate = Math.round(this.dataAge); 
      this.fromDate = Math.round(this.dataAge) + 2 
    }
    this.samId = this.data.routeStation.samId
    this.deviceName = this.data.routeStation.name
    var ios = this.data.schemaInfo?.digitalIOs ?? [];
    ios.forEach((io: any) => {
      let deStr = io.cInfo.channel.de.toString();
      let deId = "de"+deStr;
      if (io.cInfo.channel.deType == DataEndChannelTypeEnum.DIGITALINPUT || io.cInfo.channel.deType == DataEndChannelTypeEnum.DIGITALOUTPUT) {
        if (this.chartDefs[deId]["de"] == deStr)
          this.ioChannelsActive[deId] = false;
        else
          console.warn("(dioChart) not find channel definition for de: "+deStr);
      }  
    });
    
    // If there are any ios, per default activate the first for display....
    var deIds = Object.keys(this.ioChannelsActive);
    if (deIds.length > 0) {
      this.ioChannelsActive[deIds[0]] = true; 
    }

    this.nowAsISOString = this.now.toISOString()
    let d = new Date();
    d.setDate(d.getDate() - 2);
    this.twoDaysAgoAsString = d.toISOString()
  }

  ngOnDestroy(): void {
    Object.keys(this.chartDefs).forEach(id => Chart.getChart(id)?.destroy());
  }

  ngOnInit(): void {
    this.getData();
  }

  public onChannelNameChange(newValue: any, deId: string) {
    this.chartDefs[deId]['title'] = newValue;
    if (this.ioChannelsActive[deId] == true) {
      this.updateGraphics([deId]);
    }
  }

  public isActive(ioChannelKey:string): boolean {
      return (this.ioChannelsActive[ioChannelKey]);
  }
  public changeCheckValue(ioChannelKey:string) {
      this.ioChannelsActive[ioChannelKey] = !(this.ioChannelsActive[ioChannelKey]);

      // ToDO Some better way to do this?
      // Update of the iChannelsActive has consequences for DOM: canvas hidden or not.
      // It seems that this has to be done, before the charts with their ids can be redrawn... 
      // So waiting a while here seems to work, but.....
      // Also just updating the new graphics does not work
      setTimeout(() => {
      this.updateGraphics(undefined);
    }, 100);
    
  }
  private getData(): void {
    var ioChannelReqs :  {[key: string]:string} = {};
    var ioIds = Object.keys(this.ioChannelsActive);
    ioIds.forEach(id => {
      ioChannelReqs[this.chartDefs[id]["de"]] = this.chartDefs[id]["title"];
    });
    this.reportingService.getDIOGraphics(
      { utcFrom: this.twoDaysAgoAsString, 
        utcTo: this.nowAsISOString, 
        samId: this.samId, 
        ioChannels: ioChannelReqs }
    ).subscribe((data: DigitalIODataChannelGraphData[]) => {
      this.lastData = data;
      this.updateGraphics(undefined);
    });
  }
  public updateGraphics(keyList: string[] | undefined) {
    if (this.lastData != undefined) {
        this.lastData.forEach(ioChannelData => {
          let deStr = ioChannelData.deChannel.toString();
          let deId = "de"+deStr;
          if (this.ioChannelsActive[deId] && (keyList == undefined || keyList.find(key => key == deId))){
            this.createChart(deId, ioChannelData);      
          }
        }); 
    }
  }
  private booleanStatusToInt(status: boolean|undefined): number
  {
    return (status == undefined ? 0.0: + (-1 + 2 * (+status)));
  }
  private createChart(id:string, data: DigitalIODataChannelGraphData): void {
    const labels = data.ioChannelTimeData.map(d => d.time);
    const status = data.ioChannelTimeData.map(d => this.booleanStatusToInt(d.active ?? undefined));

    var dataLabel= this.chartDefs[id]["title"];
    var color = this.chartDefs[id]["color"];
    const chartInstance = Chart.getChart(id);
      if (chartInstance) {
        chartInstance.destroy();
    }

    new Chart(id, {
      type: 'line',
      data: {
        labels,
        datasets: [
          {
            label: dataLabel,
            data: status,
            borderColor: color,
            backgroundColor: color,
            fill: false,
            tension: 0.1,
            borderWidth: 1,
            pointRadius: 2,
            pointHoverRadius: 4,

            borderDash: [6, 3],
            pointStyle: 'rectRounded',
          }
        ]
      },
      options: {
        aspectRatio: 7.5,
        scales: {
          x: {
            type: 'time',
            time: {
              // Parser entfernt – ISO wird direkt erkannt
              unit: 'hour',
              displayFormats: {
                hour: 'dd.MM HH:mm',
                minute: 'dd.MM HH:mm',
              },
            },
            title: { display: true }, /* , text: 'Zeit'  */
            grid:
            {
              display: true
            }
          },
          y: {
            title: { display: true, text: 'Status' },
            min:-2.0,
            max:2.0,
            grid:
            {
              display: true
            },
            beginAtZero: true,
            ticks: {

              callback: function (value: any, index: any, values: any) {
                if (value  === -1) {
                  return 'deaktiv'
                }
                else if (value  === 1){
                  return 'aktiv'
                }
                else
                  return '';
              },

            }

          },
        },
        plugins: {
          legend: {
            labels: {
              font: {
                size: this.fontSize
              }
            }
          }
        }
      }
    });
  }

  public removeData(): void {
    this.getData();
  }

  public setFromDate(date: number): void {
    this.fromDate = date
    let d = new Date();
    d.setDate(d.getDate() - this.fromDate);
    this.twoDaysAgoAsString = d.toISOString()
  }

  public setToDate(date: number): void {
    this.toDate = date
    let d = new Date();
    d.setDate(d.getDate() - this.toDate);
    this.nowAsISOString = d.toISOString()
  }

  public onCloseDialogClicked(): void {
    this.dialogRef.close();
  }

  public exportChart(): void {
    var allCanvas: HTMLCanvasElement[] = [];
    var height: number = 0;
    var width: number = 0;
    var allIds = Object.keys(this.ioChannelsActive);
    allIds.forEach(id => {
      let canvas = document.getElementById(id) as HTMLCanvasElement;
      if (canvas != null && !canvas.hidden) {
        height += (canvas.height+20);
        width = canvas.width;
        allCanvas.push(canvas);
      }
    });
    
    const combinedCanvas = document.createElement('canvas');
    combinedCanvas.width = width;
    combinedCanvas.height = height - 20;

    const ctx = combinedCanvas.getContext('2d');
    if (ctx) {
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, combinedCanvas.width, combinedCanvas.height);
      var x: number = 0;
      var currentY: number = 0;
      allCanvas.forEach(c=> {
        ctx.drawImage(c, x, currentY);
        currentY += (c.height+20);
      });

    let dataURL = combinedCanvas.toDataURL('image/png');
    let link = document.createElement('a');
    link.href = dataURL;
    link.download = `digitalIO-verlauf-${this.samId}-${new Date().toISOString().split('T')[0]}.png`;
    link.click();
    }
  }
}